import { gql } from '@apollo/client';
import { ProductionOrderInfo } from '../fragments';

export default gql`
  query productionOrder($id: ID) {
    productionOrder(id: $id) {
      ...ProductionOrderInfo
    }
  }
  ${ProductionOrderInfo}
`;
